import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomThunder = (props: SvgIconProps): JSX.Element => (
    <SvgIcon {...props}>
        <path d="M5.83333 18.3334L9.16667 12.0834L2.5 11.2501L12.5 1.66675H14.1667L10.8333 7.91675L17.5 8.75008L7.5 18.3334H5.83333Z" />
    </SvgIcon>
);
